// extracted by mini-css-extract-plugin
module.exports = {"container":"FYPtS","tooltip-wrapper":"_3mjoY","tooltipWrapper":"_3mjoY"};